import styled from "styled-components";

export const NavigationItem = styled.div<{ isHighlighted?: boolean; $isCollapsed?: boolean }>`
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  background-color: ${(props) => (props.isHighlighted ? "rgba(255, 255, 255, 0.16)" : "transparent")};
  border-left: ${(props) => (props.isHighlighted ? "4px solid #FF8310" : "4px solid transparent")};
  border-radius: ${(props) => (props.$isCollapsed ? "8px" : "0 10px 10px 0")};
  margin: 4px ${(props) => (props.$isCollapsed ? "8px" : "8px 8px 0 0")};
  font-weight: ${(props) => (props.isHighlighted ? "600" : "400")};
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$isCollapsed ? "center" : "flex-start")};
  height: 40px;
  box-sizing: border-box;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`;

export const Divisor = styled.div<{ $isCollapsed?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$isCollapsed ? "center" : "flex-start")};
  width: 100%;
`;